import { Button, Icon, Box } from '@ace-clublabs/shared-component-library';
import { INewMembershipInfo } from '@lib/types';
import { useState } from 'react';
import { UtagType } from '../../utils/UtagHelper';
import { MembershipTerm } from '../../utils/helpers';

interface IMembershipTermSelector {
  membershipInfo: INewMembershipInfo;
  togglePayTerm: () => void;
  selectedTerm: MembershipTerm;
  sendTag: (type: UtagType, page: string, overrides?: object) => void;
  hasGreenBoxMessage: boolean;
}

export const MembershipTermSelector = ({
  membershipInfo,
  togglePayTerm,
  selectedTerm,
  sendTag,
  hasGreenBoxMessage,
}: IMembershipTermSelector) => {
  const handleToggleSwitch = () => {
    togglePayTerm();
    setIsAnnual(!isAnnual);
    sendTag(UtagType.dispatch, 'select level');
  };

  const canOnlySelectMP =
    membershipInfo.allowedBillPlans.includes('MP') && membershipInfo.allowedBillPlans.length === 1;
  const monthlyNotAllowed = !membershipInfo.allowedBillPlans.includes('MP');
  const hideSelectPayPlan = monthlyNotAllowed || canOnlySelectMP;

  const [isAnnual, setIsAnnual] = useState(selectedTerm === 'annual');

  return (
    <div hidden={hideSelectPayPlan} style={{ width: '100%', maxWidth: '21.45rem' }}>
      <Box
        sx={{
          display: 'inline-flex',
          backgroundColor: '#EAEAEC',
          borderRadius: '20px',
          marginBottom: '1.5rem',
          width: '100%',
          height: '2.5rem',
          alignItems: 'center',
        }}
        className="bill-plan-toggle-section"
      >
        <Button
          onClick={handleToggleSwitch}
          sx={{
            borderRadius: '999px',
            textTransform: 'none',
            backgroundColor: !isAnnual ? '#fff' : 'transparent',
            boxShadow: !isAnnual ? '0px 1px 5px rgba(0,0,0,0.1)' : 'none',
            px: 3,
            color: '#333',
            fontWeight: !isAnnual ? 'bold' : 'normal',
            width: '50%',
            height: '2.375rem',
            border: !isAnnual ? '1px solid #CACDCE' : 'none',
            '&:hover': {
              background: !isAnnual ? '#EFF7FE' : 'transparent',
              border: !isAnnual ? '1px solid #CACDCE' : 'none',
            },
          }}
          label={'Monthly'}
          variant={!isAnnual ? 'contained' : 'text'}
          className="select-monthly-plan"
        />
        <Button
          onClick={handleToggleSwitch}
          sx={{
            borderRadius: '999px',
            textTransform: 'none',
            backgroundColor: isAnnual ? '#fff' : 'transparent',
            boxShadow: isAnnual ? '0px 1px 5px rgba(0,0,0,0.1)' : 'none',
            px: 3,
            color: '#333',
            fontWeight: isAnnual ? 'bold' : 'normal',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            width: '50%',
            height: '2.375rem',
            border: isAnnual ? '1px solid #CACDCE' : 'none',
            '&:hover': {
              background: isAnnual ? '#EFF7FE' : 'transparent',
              border: isAnnual ? '1px solid #CACDCE' : 'none',
            },
          }}
          label="Annual"
          endIcon={
            hasGreenBoxMessage && <Icon className="tag-icon" iconName="tags-duotone" sx={{ color: '#7527B9' }} />
          }
          variant={isAnnual ? 'contained' : 'text'}
          className="select-annual-plan"
        />
      </Box>
    </div>
  );
};
